(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function ($) {
            'use strict';

            var initFallbackSlider = function initFallbackSlider(swiperElement) {
                var root = swiperElement.closest('.offers-of-day-list');
                if (!root) {
                    return;
                }

                var nextEl = root.querySelector('.js-offers-of-day-list-next');
                var prevEl = root.querySelector('.js-offers-of-day-list-prev');
                var step = function step() {
                    return Math.max(320, Math.round(swiperElement.clientWidth * 0.8));
                };
                var epsilon = 2;

                var updateControls = function updateControls() {
                    var maxScrollLeft = swiperElement.scrollWidth - swiperElement.clientWidth;
                    var isAtStart = swiperElement.scrollLeft <= epsilon;
                    var isAtEnd = swiperElement.scrollLeft >= maxScrollLeft - epsilon;

                    if (prevEl) {
                        prevEl.disabled = isAtStart;
                        prevEl.classList.toggle('swiper-button-disabled', isAtStart);
                    }
                    if (nextEl) {
                        nextEl.disabled = isAtEnd;
                        nextEl.classList.toggle('swiper-button-disabled', isAtEnd);
                    }
                };

                if (prevEl) {
                    prevEl.addEventListener('click', function () {
                        swiperElement.scrollBy({
                            left: -step(),
                            behavior: 'smooth'
                        });
                    });
                }

                if (nextEl) {
                    nextEl.addEventListener('click', function () {
                        swiperElement.scrollBy({
                            left: step(),
                            behavior: 'smooth'
                        });
                    });
                }

                swiperElement.addEventListener('scroll', updateControls, { passive: true });
                window.addEventListener('resize', updateControls);

                swiperElement.classList.add('offers-of-day-list__swiper--inited', 'offers-of-day-list__swiper--fallback');
                updateControls();
            };

            var initDesktopOffersOfDaySlider = function initDesktopOffersOfDaySlider() {
                var swipers = document.querySelectorAll('.js-offers-of-day-list-swiper');
                if (!swipers.length) {
                    return;
                }

                Array.prototype.forEach.call(swipers, function (swiperElement) {
                    if (swiperElement.dataset.inited === '1') {
                        return;
                    }

                    swiperElement.dataset.inited = '1';

                    if (typeof Swiper === 'undefined') {
                        initFallbackSlider(swiperElement);
                        return;
                    }

                    var root = swiperElement.closest('.offers-of-day-list');
                    var nextEl = root ? root.querySelector('.js-offers-of-day-list-next') : null;
                    var prevEl = root ? root.querySelector('.js-offers-of-day-list-prev') : null;

                    new Swiper(swiperElement, {
                        direction: 'horizontal',
                        slidesPerView: 'auto',
                        spaceBetween: 12,
                        freeMode: true,
                        freeModeMomentum: true,
                        watchOverflow: true,
                        navigation: {
                            nextEl: nextEl,
                            prevEl: prevEl
                        }
                    });

                    swiperElement.classList.add('offers-of-day-list__swiper--inited');
                });
            };

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', initDesktopOffersOfDaySlider);
            } else {
                initDesktopOffersOfDaySlider();
            }

            $('body').on('click', '.js-offer-of-day-card', function (e) {
                if (typeof window.showPageLoader === 'function') {
                    window.showPageLoader();
                }
                if (window.brxTracking && typeof window.brxTracking.sendAnalyticsEvent === 'function') {
                    window.brxTracking.sendAnalyticsEvent('hot_deals_view');
                }
                window.location.href = e.currentTarget.dataset.url || e.currentTarget.href;
            }).on('click', '.offers-of-day-list__more-btn', function () {
                window.brxTracking.sendAnalyticsEvent('hot_deals_view_all_click');
                window.showPageLoader();
            });
        })(jQuery);
    }, {}] }, {}, [1]);